import React from 'react';
import { Instagram, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="bg-dark text-white pt-24 pb-12" data-id="element-90">
      <div className="container mx-auto px-6 md:px-12" data-id="element-91">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-92">
          <div data-id="element-93">
            <div className="mb-8" data-id="element-94">
              <span className="font-heading text-3xl font-semibold tracking-wide text-white block" data-id="element-95">
                Валентина
              </span>
              <span className="text-[10px] uppercase tracking-widest text-gray-400" data-id="element-96">
                майстер-перукар
              </span>
            </div>

            <div className="space-y-4 text-gray-400 font-light text-sm" data-id="element-97">
              <a href="tel:+380971214358" className="flex items-center hover:text-accent transition-colors w-fit" data-id="element-98">
                <Phone size={16} className="mr-3" data-id="element-99" />
                +38 097 121 43 58
              </a>
              <a href="#" className="flex items-center hover:text-accent transition-colors w-fit" data-id="element-100">
                <Instagram size={16} className="mr-3" data-id="element-101" />
                @valentina_hair
              </a>
              <div className="flex items-center" data-id="element-102">
                <MapPin size={16} className="mr-3" data-id="element-103" />
                Центральний район, м. Київ
              </div>
            </div>
          </div>

          <div className="md:flex md:justify-end" data-id="element-104">
            <div data-id="element-105">
              <h4 className="font-heading text-xl mb-6" data-id="element-106">Меню</h4>
              <ul className="space-y-3 text-sm text-gray-400 font-light" data-id="element-107">
                <li data-id="element-108">
                  <a href="#services" className="hover:text-accent transition-colors" data-id="element-109">
                    Послуги
                  </a>
                </li>
                <li data-id="element-110">
                  <a href="#courses" className="hover:text-accent transition-colors" data-id="element-111">
                    Курси
                  </a>
                </li>
                <li data-id="element-112">
                  <a href="#gallery" className="hover:text-accent transition-colors" data-id="element-113">
                    Мої роботи
                  </a>
                </li>
                <li data-id="element-114">
                  <a href="#about" className="hover:text-accent transition-colors" data-id="element-115">
                    Про мене
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500 font-light" data-id="element-116">
          <p data-id="element-117">
            &copy; {new Date().getFullYear()} Валентина. Всі права захищені.
          </p>
          <p className="mt-4 md:mt-0" data-id="element-118">
            Сайт створено командою{' '}
            <a href="https://jetly.agency/ua" target="_blank" rel="noreferrer" className="text-white hover:text-accent transition-colors font-medium" data-id="element-119">
              jetly.agency
            </a>
          </p>
        </div>
      </div>
    </footer>;
}